<template>
  <div
    style="display: flex; background: #f3f3f3; overflow: hidden; height: 100%;"
  >
    <div style="width: 60px;">
      <div
        tab
        :class="{ active: activeTab == 'kontrak' }"
        @click="activeTab = 'kontrak'"
      >
        <v-icon large>mdi-file</v-icon>
      </div>
      <div
        tab
        :class="{ active: activeTab == 'pembayaran' }"
        @click="activeTab = 'pembayaran'"
      >
        <v-icon large>mdi-cash</v-icon>
      </div>
      <div
        tab
        :class="{ active: activeTab == 'kontraktor' }"
        @click="activeTab = 'kontraktor'"
      >
        <v-icon large>mdi-office-building-outline</v-icon>
      </div>
      <div
        tab
        :class="{ active: activeTab == 'panitia' }"
        @click="activeTab = 'panitia'"
      >
        <v-icon large>mdi-account-group</v-icon>
      </div>
    </div>
    <div style="padding: 10px; background: white; padding:20px; width: 100%;">
      <div v-show="activeTab == 'kontrak'" class="tab-page">
        <div>
          DATA KONTRAK
        </div>
        <hr />
        <div>
          <Input type="hidden" :value.sync="form.Addendum" />
          <Input type="hidden" :value.sync="form.KontrakID" />

          <Label label="No & Tgl DPA - SKPD">
            <Input type="text" :value.sync="form.NoDPA" />
            <DatePicker
              :value.sync="form.TglDPA"
              width="150px"
              style="margin-left:8px;"
            />
          </Label>
          <Label label="No & Tgl Kontrak">
            <Input type="text" :value.sync="form.NoKontrak" />
            <DatePicker
              :value.sync="form.TglKontrak"
              width="150px"
              style="margin-left:8px;"
            />
          </Label>
          <Label label="No & Tgl SPMK">
            <Input type="text" :value.sync="form.NoSPMK" />
            <DatePicker
              :value.sync="form.TglSPMK"
              width="150px"
              style="margin-left:8px;"
            />
          </Label>
          <Select
            label="Nama Kegiatan"
            dbref="MST.SelKegiatan"
            :dbparams="{ BalaiID: balaiId }"
            :placeholder="form.UpUpNamaKegiatan || 'Pilih Kegiatan'"
            :value.sync="form.UpUpKegiatanID"
            :text="form.UpUpNamaKegiatan"
            :key="form.UpUpKegiatanID"
            width="424px"
          />
          <Select
            label="Nama Sub Kegiatan"
            dbref="MST.SelKegiatan"
            :dbparams="{
              ParentID: form.UpUpKegiatanID || -1,
              BalaiID: form.UpUpKegiatanID ? balaiId : null,
            }"
            :placeholder="form.UpNamaKegiatan || 'Pilih Sub Kegiatan'"
            :value.sync="form.UpKegiatanID"
            :text="form.UpNamaKegiatan"
            :key="form.UpKegiatanID"
            width="424px"
          />
          <Select
            label="Nama Sub Sub Kegiatan"
            dbref="MST.SelKegiatan"
            :dbparams="{
              ParentID: form.UpKegiatanID || -1,
              BalaiID: form.UpKegiatanID ? balaiId : null,
            }"
            :placeholder="form.NamaKegiatan || 'Pilih Sub Sub Kegiatan'"
            :value.sync="form.KegiatanID"
            :text="form.NamaKegiatan"
            :key="form.KegiatanID"
            width="424px"
          />
          <Select
            label="Kategori"
            dbref="MST.SelKategori"
            placeholder="Pilih Kategori"
            :value.sync="form.Kategori"
            width="424px"
          />
          <Input
            label="Nama Paket & Uraian"
            :value.sync="form.NamaPaket"
            placeholder="Nama Paket"
            width="424px"
            required
          />
          <TextArea
            :value.sync="form.UraianPaket"
            width="424px"
            style="height:100px;"
            placeholder="Uraian"
          />
          <Label label="Sumber Dana & Tahun Anggaran">
            <Select
              dbref="DOC.SelSumberDana"
              :value.sync="form.SumberDana"
              placeholder="Sumber Dana"
            />
            <Input
              type="number"
              format="#000"
              :value="form.TahunAnggaran"
              style="margin-left:8px;"
            />
          </Label>
          <Label label="Jangka Waktu Pelaksanaan (Tgl Mulai - Selesai)">
            <DatePicker :value.sync="form.TglMulai" />
            <DatePicker
              :value.sync="form.TglSelesai"
              style="margin-left:8px;"
            />
          </Label>
          <Label label="Jangka Waktu Pemeliharaan & Tanggal FHO">
            <!-- <Input
              type="number"
              :value.sync="form.JangkaPemeliharaan"
              format="#.##0,"
              postfix="(hari)"
            /> -->
            <Select
              :value.sync="jangkaPemeliharaan"
              :items="[
                { val: 0, txt: 'Tanpa Pemeliharaan' },
                { val: 180, txt: '6 bulan' },
                { val: 360, txt: '1 Tahun' },
                { val: 360 * 3, txt: '3 Tahun' },
              ]"
              :required="true"
            ></Select>
            <DatePicker
              v-show="form.JangkaPemeliharaan"
              :disabled="true"
              :value="tglPHO"
              style="margin-left:8px;"
            />
          </Label>
          <TextArea
            label="Ketentuan Sanksi"
            :value.sync="form.KetentuanSanksi"
            width="424px"
            style="height:120px;"
          />
        </div>

        <!--
        <a
          href="javascript:$Page().SendWarnEmail()"
          class="hide"
          style="color:red; font-size:small;"
          >Kirim Email Teguran Jatuh Tempo</a
        > -->
      </div>
      <div v-show="activeTab == 'kontraktor'" class="tab-page">
        <div>
          KONTRAKTOR
        </div>
        <hr />
        <div>
          <Search
            label="Nama Kontraktor"
            :text.sync="form.NamaKontraktor"
            textKey="NamaKontraktor"
            dbref="MST.SelKontraktor"
            @change="KontraktorChange"
            width="424px"
          />
          <TextArea
            :value.sync="form.AlamatKontraktor"
            width="424px"
            style="height:70px;"
            label="Alamat Kontraktor"
          ></TextArea>
          <Input
            :value.sync="form.NamaDirektur"
            label="Nama Direktur"
            width="424px"
          />
          <Label label="Email & No. HP" width="424px">
            <Input
              :value.sync="form.Email"
              placeholder="Alamat Email"
              width="236px"
            />
            <Input
              :value.sync="form.NoHP"
              placeholder="No. HP (WhatsApp)"
              style="margin-left:8px;"
            />
          </Label>
          <Label label="Nama Rekening & No Rekening">
            <Input
              :value.sync="form.NamaRekening"
              placeholder="Nama Rekening"
              width="236px"
            />
            <Input
              :value.sync="form.NoRekening"
              placeholder="No Rekening"
              style="margin-left:8px;"
            />
          </Label>
          <Input :value.sync="form.NamaBank" label="Nama Bank" width="424px" />
          <Input :value.sync="form.NoNPWP" label="No NPWP" width="424px" />
          <br />
        </div>
      </div>
      <div v-show="activeTab == 'pembayaran'" class="tab-page">
        <div>
          PEMBAYARAN
        </div>
        <hr />
        <div>
          <Input
            label="Nilai Kontrak"
            type="number"
            :value.sync="form.NilaiKontrak"
            placeholder="0.000.000,00"
            format="#.##0,00"
            required
          />
          <Label label="Jenis Pembayaran">
            <Select
              :value.sync="form.CaraPembayaran"
              :items="[
                { val: 1, txt: 'Sekali Bayar' },
                { val: 2, txt: 'Termin' },
                { val: 3, txt: 'Bulanan' },
              ]"
              :required="true"
            ></Select>
            <Checkbox
              :text="'Dengan Uang Muka'"
              :value.sync="form.UseDP"
              style="margin-left: 50px; margin-top:3px;"
              @change="RenderTerminDesc"
              v-show="form.CaraPembayaran > 1"
            >
            </Checkbox>
          </Label>
          <Grid
            :datagrid.sync="form.XmlTerminDetail"
            :columns="[
              { name: 'Termin', value: 'TerminDesc', width: '120px' },
              { name: 'Tgl Penyerahan', value: 'TglSelesai' },
              { name: 'Nilai', value: 'NilaiTermin' },
              { name: '', value: 'Delete' },
            ]"
            :disabled="true"
            :key="renderTermin"
            style="margin-top:-7px;"
          >
            <template v-slot:row-TglSelesai="{ row }">
              <DatePicker :value.sync="row.TglSelesai" />
            </template>
            <template v-slot:row-NilaiTermin="{ row }">
              <!-- <input
                type="number"
                style="padding: 4px 6px; border: 0;
                  background: rgba(200, 200, 200, 0.4);
                  border-bottom: 1px solid gray;"
                v-model="row.NilaiTermin"
              /> -->
              <Input type="number" :value.sync="row.NilaiTermin" />
            </template>
            <template v-slot:row-Delete="{ idx }">
              <v-icon color="error" @click="DeleteRowTermin(idx)">
                mdi-trash-can
              </v-icon>
            </template>
          </Grid>
          <br />
          <v-btn
            small
            text
            color="primary"
            @click="TambahTermin"
            v-show="form.CaraPembayaran > 1"
          >
            <v-icon left>mdi-plus-circle</v-icon>
            Tambah
          </v-btn>
          <br />
          <br />
          <Label label="Adendum" />
          <Grid
            :datagrid.sync="form.XmlAdendumDetail"
            :columns="[
              { name: 'Adendum', value: 'Addendum' },
              { name: 'Tgl Adendum', value: 'TglAddendum' },
              { name: 'Nilai Adendum', value: 'NilaiAddendum' },
              { name: '', value: 'Delete' },
            ]"
            :disabled="true"
            :key="'a-' + renderAdendum"
          >
            <template v-slot:row-TglAddendum="{ row }">
              <DatePicker :value.sync="row.TglAddendum" />
            </template>
            <template v-slot:row-NilaiAddendum="{ row }">
              <Input type="number" :value.sync="row.NilaiAddendum" />
            </template>
            <template v-slot:row-Delete>
              <v-icon color="error" @click="DeleteAddendum(idx)">
                mdi-trash-can
              </v-icon>
            </template>
          </Grid>
          <br />
          <v-btn small text color="primary" @click="TambahAdendum">
            <v-icon left>mdi-plus-circle</v-icon>
            Tambah Adendum
          </v-btn>
        </div>
      </div>
      <div v-show="activeTab == 'panitia'" class="tab-page">
        <div>
          PANITIA
        </div>
        <hr />
        <div>
          <Select
            label="Jumlah Panitia"
            :value.sync="form.JmlPanitia"
            :items="[
              { val: 1, txt: '1 (Satu)' },
              { val: 3, txt: '3 (Tiga)' },
              { val: 5, txt: '5 (Lima)' },
              { val: 7, txt: '7 (Tujuh)' },
            ]"
            width="424px"
          >
          </Select>
          <div class="tform">Susunan Panitia Pemeriksa Hasil Pekerjaan</div>
          <Label v-show="form.JmlPanitia >= 1">
            <Input
              :value.sync="form.Panitia1"
              placeholder="Nama Panitia 1"
              width="236px"
            />
            <Input
              :value.sync="form.JbtnPanitia1"
              placeholder="Jabatan Panitia 1"
              style="margin-left:8px"
            />
          </Label>
          <Label id="Panitia2" v-show="form.JmlPanitia >= 2">
            <Input
              :value.sync="form.Panitia2"
              placeholder="Nama Panitia 2"
              width="236px"
            />
            <Input
              :value.sync="form.JbtnPanitia2"
              placeholder="Jabatan Panitia 2"
              style="margin-left:8px"
            />
          </Label>
          <Label id="Panitia3" v-show="form.JmlPanitia >= 3">
            <Input
              :value.sync="form.Panitia3"
              placeholder="Nama Panitia 3"
              width="236px"
            />
            <Input
              :value.sync="form.JbtnPanitia3"
              placeholder="Jabatan Panitia 3"
              style="margin-left:8px"
            />
          </Label>
          <Label id="Panitia4" v-show="form.JmlPanitia >= 4">
            <Input
              :value.sync="form.Panitia4"
              placeholder="Nama Panitia 4"
              width="236px"
            />
            <Input
              :value.sync="form.JbtnPanitia4"
              placeholder="Jabatan Panitia 4"
              style="margin-left:8px"
            />
          </Label>
          <Label id="Panitia5" v-show="form.JmlPanitia >= 5">
            <Input
              :value.sync="form.Panitia5"
              placeholder="Nama Panitia 5"
              width="236px"
            />
            <Input
              :value.sync="form.JbtnPanitia5"
              placeholder="Jabatan Panitia 5"
              style="margin-left:8px"
            />
          </Label>
          <Label id="Panitia6" v-show="form.JmlPanitia >= 6">
            <Input
              :value.sync="form.Panitia6"
              placeholder="Nama Panitia 6"
              width="236px"
            />
            <Input
              :value.sync="form.JbtnPanitia6"
              placeholder="Jabatan Panitia 6"
              style="margin-left:8px"
            />
          </Label>
          <Label id="Panitia7" v-show="form.JmlPanitia >= 7">
            <Input
              :value.sync="form.Panitia7"
              placeholder="Nama Panitia 7"
              width="236px"
            />
            <Input
              :value.sync="form.JbtnPanitia7"
              placeholder="Jabatan Panitia 7"
              style="margin-left:8px"
            />
          </Label>
          <Label label="SK Panitia">
            <Input
              :value.sync="form.NoSKPanitia"
              placeholder="No SK Panitia"
              width="236px"
            />
            <DatePicker
              :value.sync="form.TglSKPanitia"
              placeholder="Tgl SK"
              style="margin-left:8px"
            />
          </Label>
        </div>
      </div>
      <div style="display:flex;">
        <v-btn color="primary" @click="Save">SIMPAN</v-btn>
        <v-btn
          color="primary"
          text
          @click="DownloadVerifikasi"
          v-if="form.IsLocked"
        >
          DOWNLOAD HALAMAN VERIFIKASI
        </v-btn>
        <v-spacer />
        <v-btn color="error" text @click="Delete" v-if="!form.IsLocked">
          HAPUS
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from '../../components/Forms/DatePicker.vue'
import moment from 'moment'

export default {
  components: { DatePicker },
  data: () => ({
    activeTab: 'kontrak',
    form: {
      TahunAnggaran: localStorage.getItem('tahun'),
      XmlTerminDetail: [],
      XmlAdendumDetail: [],
    },
    renderTermin: 0,
    renderAdendum: 0,
  }),
  props: {
    kontrakId: [String, Number],
    balaiId: [String, Number],
  },
  computed: {
    tglPHO() {
      if (this.form.JangkaPemeliharaan)
        return moment(this.form.TglSelesai).add(
          this.form.JangkaPemeliharaan,
          'days'
        )
      else return ''
    },
    jangkaPemeliharaan: {
      get() {
        return this.form.JangkaPemeliharaan
      },
      set(val) {
        switch (val) {
          case 0:
            this.form.JangkaPemeliharaan = 0
            break
          case 180:
            this.form.JangkaPemeliharaan = moment(this.form.TglSelesai)
              .add(6, 'months')
              .diff(this.form.TglSelesai, 'days')
            break
          case 360:
            this.form.JangkaPemeliharaan = moment(this.form.TglSelesai)
              .add(1, 'year')
              .diff(this.form.TglSelesai, 'days')
            break
          case 360 * 3:
            this.form.JangkaPemeliharaan = moment(this.form.TglSelesai)
              .add(3, 'year')
              .diff(this.form.TglSelesai, 'days')
            break
        }
      },
    },
  },
  watch: {
    'form.CaraPembayaran'(val) {
      if (val === 1) this.form.UseDP = false
      this.RenderTerminDesc()
    },
  },
  mounted() {
    this.Populate()
  },
  methods: {
    async Populate() {
      let res = await this.$api.call('DOC.SelKontrak', {
        KontrakID: this.kontrakId,
      })
      let resDet = await this.$api.call('DOC.SelKontrakTermin', {
        KontrakID: this.kontrakId,
      })
      let resDum = await this.$api.call('DOC.SelKontrakAdendum', {
        KontrakID: this.kontrakId,
      })
      if (res.data && res.data.length) {
        this.form = Object.assign(
          {
            TahunAnggaran: localStorage.getItem('tahun'),
            XmlTerminDetail: resDet ? resDet.data || [] : [],
            XmlAdendumDetail: resDum ? resDum.data || [] : [],
          },
          res.data[0]
        )
        if (resDet && resDet.data && resDet.data.length) {
          if (resDet.data[0].TerminDesc === 'Uang Muka') {
            this.form.UseDP = true
          } else {
            this.form.UseDP = false
          }
        }
      }
    },
    ResetForm() {
      this.form = {
        TahunAnggaran: localStorage.getItem('tahun'),
        XmlTerminDetail: [],
      }
    },
    TambahTermin() {
      this.form.XmlTerminDetail.push({
        TerminDesc: 'Termin',
        TglSelesai: moment().format('YYYY-MM-DD'),
        NilaiTermin: 0,
      })
      this.RenderTerminDesc()
    },
    TambahAdendum() {
      this.form.XmlAdendumDetail.push({
        Addendum: this.form.XmlAdendumDetail.length + 1,
        TglAddendum: moment().format('YYYY-MM-DD'),
        NilaiAddendum: 0,
      })
      // this.RenderTerminDesc()
      this.renderAdendum++
    },
    RenderTerminDesc() {
      if (!this.form.XmlTerminDetail) this.form.XmlTerminDetail = []
      if (this.form.CaraPembayaran == 1) {
        if (this.form.XmlTerminDetail.length > 1) {
          this.form.XmlTerminDetail.splice(1, 100)
        } else if (this.form.XmlTerminDetail.length == 0) {
          this.TambahTermin()
        }
        this.form.XmlTerminDetail[0].TerminDesc = 'Pelunasan'
      } else {
        let desc = 'Termin '
        if (this.form.CaraPembayaran == 3) desc = 'Bulan '
        if (this.form.UseDP) {
          for (let i = 0; i < this.form.XmlTerminDetail.length; i++) {
            let row = this.form.XmlTerminDetail[i]
            if (i == 0) {
              row.Termin = 0
              row.TerminDesc = 'Uang Muka'
            } else {
              row.Termin = i
              row.TerminDesc = desc + i
            }
          }
        } else {
          for (let i = 0; i < this.form.XmlTerminDetail.length; i++) {
            this.form.XmlTerminDetail[i].Termin = i + 1
            this.form.XmlTerminDetail[i].TerminDesc = desc + (i + 1)
          }
        }
      }
      this.renderTermin++
    },
    KontraktorChange(val) {
      this.form.AlamatKontraktor = val.AlamatKontraktor
      this.form.NamaDirektur = val.NamaDirektur
      this.form.Email = val.Email
      this.form.NoHP = val.NoHP
      this.form.NamaRekening = val.NamaRekening
      this.form.NoRekening = val.NoRekening
      this.form.NamaBank = val.NamaBank
      this.form.NoNPWP = val.NoNPWP
    },
    DeleteRowTermin(idx) {
      this.form.XmlTerminDetail.splice(idx, 1)
      this.RenderTerminDesc()
    },
    DeleteAddendum(idx) {
      this.form.XmlAdendumDetail.splice(idx, 1)
    },
    async Save() {
      let ret = await this.$api.call('DOC.SavKontrak', this.form)
      if (ret && ret.success) this.$emit('close', true)
    },
    async DownloadVerifikasi() {
      let termin = 0
      if (this.form.XmlTerminDetail.length) {
        termin = this.form.XmlTerminDetail[0].Termin
      }
      this.$api.download(
        `/api/doc/template/BUKTI_VERIFIKASI?_KontrakID=${this.kontrakId}&_Termin=${termin}`
      )
    },
    async Delete() {
      if (!confirm('Anda yakin akan menghapus kontrak?')) return
      let ret = await this.$api.call('DOC.DelKontrak', this.form)
      if (ret && ret.success) this.$emit('close', true)
    },
  },
}
</script>
<style lang="scss">
[tab] {
  padding: 10px;
  cursor: pointer;
}
[tab].active {
  background: white;
}
.tab-page {
  height: calc(100vh - 120px);
  overflow: hidden;

  & > div:first-child {
    font-family: Raleway;
    font-size: x-large;
    padding-bottom: 8px;
    margin-top: -9px;
  }
  & > div:nth-child(3) {
    height: calc(100vh - 170px);
    overflow: auto;
  }
}
</style>
